App.factory('baseService', ['$http', '$q', '$window', '$base64', '$state', '$rootScope', 'Config', '$filter', 'popUpService', function($http, $q, $window, $base64, $state, $rootScope, Config, $filter, popUpService) {

	function BaseService() {

        var self = this;

        self.clearSession = function() {
            window.sessionStorage.removeItem('isLogged');
            window.sessionStorage.removeItem('refresh_token');
            window.sessionStorage.removeItem('params');
            window.sessionStorage.removeItem('userObject');
            $rootScope.__logged = false;
            $rootScope.__isAccess = false;
            $rootScope.__isInsurer = false;
        };

        self.showErrorPopup = function (){
            popUpService.showPopUp({
                content: 'Nastąpiło wylogowanie z powodu wygaśnięcia sesji',
                hideButton: true,
                clickOutsideToClose: true,
            });
        }

        var debouncedShowErrorPopup = _.debounce(self.showErrorPopup, 200);

        self.checkError = function(error) {
            if (error.status === 401) {
                self.clearSession();
                debouncedShowErrorPopup();
                $state.go('root.login');
            } else if (error.status === 400) {
                if (error.data.error === 'invalid_grant') {
                    self.clearSession();
                    $state.go('root.login');
                }
            }
        }

        self.refreshToken = function () {
            var d = $q.defer();

            var refresh_token = window.sessionStorage.getItem('refresh_token');
            self.logged(Config.AUTH_URL, $.param({
                grant_type: 'refresh_token',
                client_id: 'xilium',
                refresh_token: refresh_token
            })).then(function (success) {
                d.resolve(success);
            }, function (error) {
                // d.reject(error);
                return error;
            });

            return d.promise;
        };

		this.post = function(url, postData, config) {
            var refresh_time = JSON.parse(window.sessionStorage.getItem('refresh_time'));
            if ($filter('dateComing')(refresh_time)) {
                return self.refreshToken().then(function (data) {
                    window.sessionStorage.setItem('isLogged', data.data.access_token);
                    window.sessionStorage.setItem('refresh_token', data.data.refresh_token);

                    return start();
                });
            } else {
                return start();
            }

            function start() {
    			var d = $q.defer();

                if (postData) {
                    $http({
                        method: 'POST',
                        url: url,
                        data: postData,
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + window.sessionStorage.getItem('isLogged')
                        }
                    }).then(function(success) {
                        d.resolve(success);
                    }, function(error) {
                        self.checkError(error);

                        d.reject(error);
                    }); 
                } else {
                    $http({
                        method: 'POST',
                        url: url,
                        data: '',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Authorization': 'Bearer ' + window.sessionStorage.getItem('isLogged')
                        }
                    }).then(function(success) {
                        d.resolve(success);
                    }, function(error) {
                        self.checkError(error);

                        d.reject(error);
                    })
                }

    			return d.promise;
            }
		};

        this.put = function(url, postData, config) {
            var refresh_time = window.sessionStorage.getItem('refresh_time');
            if ($filter('dateComing')(refresh_time)) {
                return self.refreshToken().then(function (data) {
                    window.sessionStorage.setItem('isLogged', data.data.access_token);
                    window.sessionStorage.setItem('refresh_token', data.data.refresh_token);

                    return start();
                });
            } else {
                return start();
            }

            function start() {
                var d = $q.defer();

                if (postData) {
                    $http({
                        method: 'PUT',
                        url: url,
                        data: postData,
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + window.sessionStorage.getItem('isLogged')
                        }
                    }).then(function(success) {
                        d.resolve(success);
                    }, function(error) {
                        self.checkError(error);

                        d.reject(error);
                    });
                } else {
                    $http({
                        method: 'PUT',
                        url: url,
                        data: '',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Authorization': 'Bearer ' + window.sessionStorage.getItem('isLogged')
                        }
                    }).then(function(success) {
                        d.resolve(success);
                    }, function(error) {
                        self.checkError(error);
                        
                        d.reject(error);
                    });
                }

                return d.promise;
            }
        };

        this.get = function(url, params) {
            var refresh_time = window.sessionStorage.getItem('refresh_time');
            if ($filter('dateComing')(refresh_time)) {
                return self.refreshToken().then(function (data) {
                    window.sessionStorage.setItem('isLogged', data.data.access_token);
                    window.sessionStorage.setItem('refresh_token', data.data.refresh_token);

                    return start();
                });
            } else {
                return start();
            }

            function start() {
                var d = $q.defer();

                $http({
                    method: 'GET',
                    url: url,
                    params: params,
                    data: '',
                    headers: {
                        'Accept': 'application/json, text/plain, */*',
                        'Authorization': 'Bearer ' + window.sessionStorage.getItem('isLogged')
                    }
                }).then(function(success) {
                    d.resolve(success);
                }, function(error) {
                    self.checkError(error);
                        
                    d.reject(error);
                });

                return d.promise;
            }
        };

        this.getWithOutAuth = function(url, config) {
            var d = $q.defer();

            $http({
                method: 'GET',
                url: url,
                data: '',
                headers: {
                    'Accept': 'application/json, text/plain, */*'
                }
            }).then(function(success) {
                d.resolve(success);
            }, function(error) {
                self.checkError(error);
                    
                    d.reject(error);
            });

            return d.promise;
        };

        this.confirm = function(url, postData, config) {
            var d = $q.defer();

            if (postData) {
                $http({
                    method: 'POST',
                    url: url,
                    data: postData,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(function(success) {
                    d.resolve(success);
                }, function(error) {
                    self.checkError(error);
                    
                    d.reject(error);
                });
            } else {
                $http({
                    method: 'GET',
                    url: url,
                    data: '',
                    headers: {
                        // 'Content-Type': 'application/x-www-form-urlencoded',
                    }
                }).then(function(success) {
                    d.resolve(success);
                }, function(error) {
                    self.checkError(error);
                    
                    d.reject(error);
                });
            }

            return d.promise;
        };

        this.delete = function(url, postData, config) {
            var refresh_time = window.sessionStorage.getItem('refresh_time');
            if ($filter('dateComing')(refresh_time)) {
                return self.refreshToken().then(function (data) {
                    window.sessionStorage.setItem('isLogged', data.data.access_token);
                    window.sessionStorage.setItem('refresh_token', data.data.refresh_token);

                    return start();
                });
            } else {
                return start();
            }

            function start() {
                var d = $q.defer();

                $http({
                    method: 'DELETE',
                    url: url,
                    data: postData,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + window.sessionStorage.getItem('isLogged')
                    }
                }).then(function(success) {
                    d.resolve(success);
                }, function(error) {
                    self.checkError(error);
                        
                        d.reject(error);
                }); 

                return d.promise;
            }
        };

        this.logged = function(url, postData, config) {
            var d = $q.defer();

            var encoded = btoa("xilium:");

            $http({
                method: 'POST',
                url: url,
                data: postData,
                headers: {
                    'Authorization': 'Basic ' + encoded,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }).then(function(success) {
                // @TODO <HEALTH2019>
                var expiresInSeconds = success.data.expires_in;
                var time = new Date().getTime();

                window.sessionStorage.setItem('refresh_time',  time + expiresInSeconds * 1000);
                // @TODO </HEALTH2019>
                d.resolve(success);
            }, function(error) {
                self.checkError(error);
                    
                d.reject(error);
            });

            return d.promise;
        };

        this.register = function(url, postData, config) {
            var d = $q.defer();

            $http({
                method: 'POST',
                url: url,
                data: postData,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(function(success) {
                d.resolve(success);
            }, function(error) {
                self.checkError(error);
                    
                    d.reject(error);
            }); 

            return d.promise;
        };

        this.download = function(url, postData, config) {
            var refresh_time = window.sessionStorage.getItem('refresh_time');
            if ($filter('dateComing')(refresh_time)) {
                return self.refreshToken().then(function (data) {
                    window.sessionStorage.setItem('isLogged', data.data.access_token);
                    window.sessionStorage.setItem('refresh_token', data.data.refresh_token);

                    return start();
                });
            } else {
                return start();
            }

            function start() {
                var d = $q.defer();

                if (postData) {
                    $http({
                        method: 'POST',
                        url: url,
                        data: postData,
                        headers: {
                            'Accept': 'application/json, text/plain, */*',
                            'Authorization': 'Bearer ' + window.sessionStorage.getItem('isLogged')
                        },
                        responseType: 'arraybuffer',
                        cache: false
                    }).then(function(success) {
                        d.resolve(success);
                    }, function(error) {
                        self.checkError(error);
                        
                        d.reject(error);
                    });
                } else {
                    $http({
                        method: 'GET',
                        url: url,
                        data: '',
                        headers: {
                            'Accept': 'application/json, text/plain, */*',
                            'Authorization': 'Bearer ' + window.sessionStorage.getItem('isLogged')
                        },
                        responseType: 'arraybuffer',
                        cache: false
                    }).then(function(success) {
                        d.resolve(success);
                    }, function(error) {
                        self.checkError(error);
                        
                        d.reject(error);
                    });
                }

                return d.promise;
            }
        };
        
        // @TODO: <HEALTH2019>
        this.postFormData = function (url, postData) {
            return $http({
                method: 'POST',
                url: url,
                data: postData,
                headers: {
                    'Authorization': 'Bearer ' + window.sessionStorage.getItem('isLogged'),
                    'Content-Type': undefined
                }
            })
        };

        this.postFile = function (url, postData, config) {
            var formData = new FormData();
            formData.append('file', postData);

            return $http({
                method: 'POST',
                url: url,
                data: formData,
                headers: {
                    'Authorization': 'Bearer ' + window.sessionStorage.getItem('isLogged'),
                    'Content-Type': undefined
                }
            })
        }
        // @TODO: </HEALTH2019>

	}

	return new BaseService();
}]);
